import React from 'react';
import Header from 'components/@common/PageHeader';
import Main from 'Main';
import FullScreenButton from 'components/@common/Buttons/FullScreenButton';
import ResourcesButton from 'components/@common/Buttons/ResourcesButton';
import { Divider } from '@mui/material';
import { useFullScreen } from 'state/providers/FullScreenProvider';
import SwitchEditionButton from 'components/@common/Buttons/SwitchEditionButton';

const MainHeaderLayout = ({ children, ...props }: any) => {
  const [{ isFullScreen }] = useFullScreen();

  const getEndAdornment = () => {
    if (props.allowFullScreen) {
      return (
        <div
          style={{
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <FullScreenButton />
          <Divider
            orientation="vertical"
            style={{ borderRight: '1px solid black', width: '1px', height: '100%' }}
          />
          <ResourcesButton />
        </div>
      );
    }

    if (props.path.includes('home')) {
      return <SwitchEditionButton />;
    }

    return null;
  };

  const headerProps = {
    endAdornment: getEndAdornment(),
    ...props
  };

  return (
    <Main>
      {!isFullScreen && <Header {...headerProps} />}
      {children}
    </Main>
  );
};

export default MainHeaderLayout;
